<template>
  <div class="w-100">
    <ok-cancel-dialog id="migrate-user-modal"
                      title="Migrar datos de usuario"
                      content="
                        <p>
                          <b>¿Esta seguro de migrar la información de este usuario?</b>
                          <br />
                          Al presionar el botón de confirmar esta acción no se podrá deshacer.
                        </p>
                      "
                      ok-button-text="Confirmar"
                      :ok-callback="submit"
                      ref="migrate-user-modal"></ok-cancel-dialog>
  </div>
</template>

<script>
  import OkCancelDialog from '../components/ui/OkCancelDialog'
  import 'jquery-validation'
  import 'select2'
  import 'select2/dist/js/i18n/es'
  
  export default {
    name: 'MigrateUser',
    components: {
      OkCancelDialog,
    },
    props: ['user'],
    methods: {
      showMigrateUserModal () {
        const form = $('.form')

        if (!form.valid()) {
          this.submit()

          return
        }

        $('#migrate-user-modal').modal('show')
      },
      submit () {
        $('.form').submit()
      },
    },
    mounted () {
      const vm = this
      /**
       * Init Select2 for users
       */
      const searchUsers = $('.search-users')
      
      searchUsers.select2({
        placeholder: 'Seleccione el usuario destino',
          templateResult: function (state) {
            if (state.id) {
              return $(`<p class="mb-0"> ${state.text} <small class="text-muted">(${state.email})</small></p>`)
            }

            return state.text
        },
        ajax: {
          url: '/api/v1/users',
          dataType: 'json',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
          },
          data(params) {
            return {
              q: params.term,
              page: params.page || 1,
              exclude: vm.user,
              statuses: [
                'act',
                'proc',
                'bloq',
                'inac',
                'por_confirmar',
                'pendiente',
              ],
            }
          },
          processResults(data, params) {
            params.page = params.page || 1
            
            return {
              results: data.data,
              pagination: {
                more: (params.page * 10) < data.meta.total,
              },
            }
          },
        },
      })

      searchUsers.on('select2:select', function(e) {
        const {
          id,
          employee_number,
          email,
          text,
          workplace
        } = e.params.data;

        $('#target-user .content').removeClass('d-none');
        $('#target-user .no-results').addClass('d-none');
        $('#target-user .id').html(id);
        $('#target-user .employee-number').html(employee_number);
        $('#target-user .full-name').html(`<b>${ text }</b>`);
        $('#target-user .email').html(email);
        $('#target-user .workplace').html(workplace);
      })

      /**
       * Init JQuery validation
       */
      $(() => {
        $('.form').validate({
          ignore: [],
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            if (element.hasClass('select2-input')) {
              label.insertAfter(element.siblings('span.select2'))
            } else {
              label.insertAfter(element)
            }

            label.addClass('invalid-feedback')
          },
          rules: {
            target_user: {
              required: true,
            },
          },
          messages: {
            target_user: {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler (form) {
            form.submit()
          },
        })
      })

      $('#btn-save').on('click', function () {
        vm.showMigrateUserModal()
      });
    },
  }
</script>
